import React from 'react'
import { Box } from '@fundamentals'
import { localizedStrings } from '@core/strings'
import { PermitQuestionsTabProps } from '../types'
import { RenderAnswers } from '@elements/Questions/RenderAnswers'
import WarningCard from '@modules/permitDetails/WarningCard'

export const PermitTab: React.FC<PermitQuestionsTabProps> = ({
  permit,
  onlyShowWarnings,
}) => {
  const warnings = permit?.warnings || []
  const clonedPermitWarning = warnings.find((w) => w.type === 'CLONED_PERMIT')

  return (
    <Box flex={1}>
      {clonedPermitWarning && (
        <WarningCard sx={{ mb: 1 }} warning={clonedPermitWarning} />
      )}
      <RenderAnswers
        questionBuilderAnswers={permit?.authorisedPersonAnswers}
        permitId={permit?.id}
        organisationId={permit?.template?.organisationId}
        projectId={permit?.project?.id}
        warnings={warnings}
        onlyShowWarnings={onlyShowWarnings}
        titlePrefix={localizedStrings.authorisedPerson}
      />
      {permit?.approvalReviews?.approvals
        .filter((a) => a.approval.approvalStage === 'BEFORE_PERMIT_HOLDER')
        .map(({ approval }) => (
          <RenderAnswers
            key={approval.id}
            questionBuilderAnswers={approval?.approvalAnswers}
            organisationId={permit?.template?.organisationId}
            projectId={permit?.project?.id}
            warnings={warnings}
            onlyShowWarnings={onlyShowWarnings}
            titlePrefix={localizedStrings.approval}
          />
        ))}
      <RenderAnswers
        questionBuilderAnswers={permit?.permitHolderAnswers}
        permitId={permit?.id}
        organisationId={permit?.template?.organisationId}
        projectId={permit?.project?.id}
        warnings={warnings}
        onlyShowWarnings={onlyShowWarnings}
        titlePrefix={localizedStrings.permitHolder}
      />
      {permit?.approvalReviews?.approvals
        .filter((a) => a.approval.approvalStage === 'AFTER_PERMIT_HOLDER')
        .map(({ approval }) => (
          <RenderAnswers
            key={approval.id}
            questionBuilderAnswers={approval?.approvalAnswers}
            organisationId={permit?.template?.organisationId}
            projectId={permit?.project?.id}
            warnings={warnings}
            onlyShowWarnings={onlyShowWarnings}
            titlePrefix={localizedStrings.approval}
          />
        ))}
      <RenderAnswers
        questionBuilderAnswers={permit?.postPermitChecksAnswers}
        permitId={permit?.id}
        organisationId={permit?.template?.organisationId}
        projectId={permit?.project?.id}
        warnings={warnings}
        onlyShowWarnings={onlyShowWarnings}
        titlePrefix={localizedStrings.postPermitChecks}
      />
      {permit?.finalSignOffReviews?.reviews?.map(({ finalSignOff }) => (
        <RenderAnswers
          key={finalSignOff.id}
          questionBuilderAnswers={finalSignOff?.finalSignOffAnswers}
          organisationId={permit?.template?.organisationId}
          projectId={permit?.project?.id}
          warnings={warnings}
          onlyShowWarnings={onlyShowWarnings}
          titlePrefix={localizedStrings.finalSignOff}
        />
      ))}
    </Box>
  )
}
